import { render, staticRenderFns } from "./HistoryPanel.vue?vue&type=template&id=2e034a31&scoped=true&"
import script from "./HistoryPanel.vue?vue&type=script&lang=js&"
export * from "./HistoryPanel.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPanel.vue?vue&type=style&index=0&id=2e034a31&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e034a31",
  null
  
)

export default component.exports